import React from "react";

export default function HomeCtaSection() {
  return (
    <section className="py-24 px-6 lg:px-20">
      <div className="max-w-4xl mx-auto bg-background-dark rounded-[3rem] overflow-hidden relative fade-up shadow-3xl">
        <div className="absolute inset-0 hero-pattern-dark opacity-[0.1] pointer-events-none" />
        {/* Ambient orb */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-48 bg-primary/20 blur-3xl rounded-full pointer-events-none" />
        {/* Decorative icons */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <span
            className="material-symbols-outlined text-primary/8 absolute top-10 left-10 runner-anim"
            style={{ fontSize: "5rem", fontVariationSettings: '"FILL" 1' }}
          >
            directions_run
          </span>
          <span
            className="material-symbols-outlined text-primary/8 absolute bottom-12 right-14 coin-2"
            style={{ fontSize: "4rem", fontVariationSettings: '"FILL" 1' }}
          >
            inventory_2
          </span>
          <span
            className="material-symbols-outlined text-white/4 absolute top-20 right-20 pin-3"
            style={{ fontSize: "3.5rem", fontVariationSettings: '"FILL" 1' }}
          >
            location_on
          </span>
          <span
            className="material-symbols-outlined text-white/4 absolute bottom-16 left-20"
            style={{ fontSize: "3.5rem", fontVariationSettings: '"FILL" 1' }}
          >
            verified
          </span>
        </div>
        <div className="relative z-10 text-center p-12 lg:p-20">
          <div className="inline-flex items-center gap-2 bg-white/8 text-white/80 px-4 py-1.5 rounded-full text-xs font-black tracking-widest uppercase mb-8 border border-white/10">
            <span className="w-2 h-2 bg-primary rounded-full status-blink" />
            Join thousands of happy customers
          </div>
          <h2 className="text-4xl md:text-[3.6rem] font-black text-white mb-8 leading-[1.08]">
            Ready to reclaim
            <br />
            <span className="text-primary italic skew-heading">your time?</span>
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <button className="bg-primary text-white text-lg font-black px-12 py-5 rounded-2xl hover:scale-[1.04] transition-transform shadow-2xl shadow-primary/50 flex items-center gap-2.5 relative overflow-hidden group">
              <span className="absolute inset-0 bg-primary-deep scale-x-0 origin-left group-hover:scale-x-100 transition-transform duration-300 rounded-2xl" />
              <span
                className="material-symbols-outlined relative z-10"
                style={{ fontVariationSettings: '"FILL" 1' }}
              >
                directions_run
              </span>
              <span className="relative z-10">Send your first Runner</span>
            </button>
            <button className="border-2 border-white/15 text-white font-bold px-8 py-5 rounded-2xl hover:border-primary hover:text-primary transition-all hover:bg-primary/5">
              Become a Runner
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
